@if (item(); as item) {
  <button
    class="tw-flex tw-w-full tw-justify-between tw-rounded tw-border tw-px-2 tw-py-1 tw-text-sm hover:tw-bg-secondary-50 active:tw-bg-base-400 disabled:tw-pointer-events-none disabled:tw-opacity-50"
    [ngClass]="{
      'tw-border-secondary tw-bg-secondary-50': isSelecting(),
      'tw-bg-gray-50': !isSelecting(),
    }"
    (click)="onSelectFlight(item)"
    [disabled]="disabled()"
  >
    <div
      class="tw-flex tw-flex-col tw-items-start tw-justify-center tw-gap-0.5"
    >
      <span>{{ flightGroupClass(item) }}</span>
      <span>{{ flightFareClass(item) }}</span>
    </div>
    <div class="tw-flex tw-flex-col tw-items-end tw-justify-center tw-gap-0.5">
      @if (fareOriginalPrice(item) > 0) {
        <span class="tw-text-[0.625rem] tw-text-base-500 tw-line-through">
          {{ fareOriginalPrice(item) | number }}
        </span>
      }
      <span class="tw-font-bold tw-text-primary">
        {{ farePrice(item) | number }}
      </span>
      <span class="tw-text-secondary">
        @if (item.remainSeats > 0) {
          Còn
          <span class="tw-font-bold">{{ item.remainSeats }}</span>
          chỗ
        }
      </span>
    </div>
  </button>
}
